// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1992":"3302a0f3","4768":"45597929","6711":"48ef7e02"}[chunkId] + ".chunk.css";
};